"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = default_1;
// Third party imports
const uuid_1 = require("uuid");
const either_1 = require("../../types/either");
// Local imports
const createBooksInteriorPrintable_1 = __importDefault(require("../printables/createBooksInteriorPrintable"));
const getBookInteriorPageCount_1 = __importDefault(require("./getBookInteriorPageCount"));
const getMinMaxPagesForBookProject_1 = __importDefault(require("./getMinMaxPagesForBookProject"));
const printables_1 = require("../printables");
const constants_1 = require("../designs/constants");
const Product_1 = require("../../models/Product");
const printableModifications_1 = require("./update/printableModifications");
const designs_1 = require("../designs");
function default_1(project, action, template, art) {
  var _a;
  // Make sure the project does not already have the maximum number of interior pages (i.e., printables)
  const currentPageCount = (0, getBookInteriorPageCount_1.default)(project.printableGroups, art.category);
  const [, maxPageCount] = (0, getMinMaxPagesForBookProject_1.default)(template, art.category);
  const pagesToAdd = (0, Product_1.isSpreadBooksCategory)(art.category) ? action.numPrintablesToAdd * 2 : action.numPrintablesToAdd;
  if (currentPageCount + pagesToAdd > maxPageCount) {
    return (0, either_1.left)(new Error(`Could not add ${pagesToAdd} interior page(s) to book project ${project.id}.  Current page count is ${currentPageCount} and the max is ${maxPageCount}.`));
  }
  // Get the interior printables group; return an error if it's not found
  const interiorPrintableGroup = project.printableGroups.find(x => x.type === 'interior');
  if (!interiorPrintableGroup) {
    return (0, either_1.left)(new Error(`Could not find interior printable group for project ${project.id}`));
  }
  const newPageCount = interiorPrintableGroup.printables.length + pagesToAdd;
  const pageCountFilter = d => (0, designs_1.isDesignAllowedForPageCount)(d, newPageCount);
  const newPrintables = [];
  for (let i = 0; i < action.numPrintablesToAdd; i++) {
    const printableId = (0, uuid_1.v5)(`Time ${project.lastModifiedAt} Printable interior ${currentPageCount + i + 1}`, interiorPrintableGroup.id);
    const designFilters = [];
    if (action.mobile && action.isMobileSingleImageLayoutsSplitActive) {
      // default mobile design selection should have one image and no text per EN-5790
      designFilters.push(constants_1.MOBILE_FILTER);
    } else {
      designFilters.push(constants_1.DEFAULT_FILTER);
      designFilters.push(pageCountFilter);
    }
    if (art.userCanAddText) {
      designFilters.push(constants_1.NO_TEXT_FILTER);
    }
    const currentNumPrintables = ((_a = interiorPrintableGroup === null || interiorPrintableGroup === void 0 ? void 0 : interiorPrintableGroup.printables) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const createBooksInteriorPrintableResult = (0, createBooksInteriorPrintable_1.default)({
      projectId: project.id,
      creationDate: action.timestamp,
      userId: project.createdBy,
      template,
      interiorPrintableIdx: currentNumPrintables + i,
      printableId,
      designFilters
    });
    if (createBooksInteriorPrintableResult.isLeft()) {
      return (0, either_1.left)(createBooksInteriorPrintableResult.value);
    }
    newPrintables.push(createBooksInteriorPrintableResult.value);
  }
  const indexToInsertPrintables = typeof action.atIndex === 'number' && action.atIndex > 0 && action.atIndex < interiorPrintableGroup.printables.length ? action.atIndex : interiorPrintableGroup.printables.length;
  interiorPrintableGroup.printables.splice(indexToInsertPrintables, 0, ...newPrintables);
  const updateBookCoverPrintableIfNeededResult = (0, printables_1.updateBookCoverPrintableIfNeeded)(template, project, action.timestamp);
  if (updateBookCoverPrintableIfNeededResult.isLeft()) {
    return (0, either_1.left)(updateBookCoverPrintableIfNeededResult.value);
  }
  const numInteriorPrintables = interiorPrintableGroup.printables.length;
  project = (0, printableModifications_1.modifyProjectForPrintableModifications)(project, art, numInteriorPrintables);
  const updatedEntities = [project, ...newPrintables];
  if (updateBookCoverPrintableIfNeededResult.isRight() && !!updateBookCoverPrintableIfNeededResult.value) {
    updatedEntities.push(updateBookCoverPrintableIfNeededResult.value);
  }
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities: updatedEntities
  });
}